import { SettingsFormModel } from 'src/Libs/emergency-power'
import { EmergencyPowerSettingsUpdateDto } from 'src/Libs/emergency-power/api/dto'

/**
 * TODO: it is not clear at the moment on what conditions or arrangements  specific settings can be update.
 * @param formValues
 */
const settingsFormToDtoTransformer = (formValues: SettingsFormModel): EmergencyPowerSettingsUpdateDto => {
  const model = {
    delay: formValues.delay,
    partialGrid: formValues.partialGrid,
    reserve: {
      reserveW: formValues.reserve,
    },
    wallbox: {
      allow: formValues.wallboxAllow,
      energy: formValues.wallboxEnergy,
      maxEpPower: formValues.wallboxMaxEpPower ?? 0,
      minEpPower: formValues.wallboxMinEpPower ?? 0,
    },
  } as EmergencyPowerSettingsUpdateDto

  return model
}
export default settingsFormToDtoTransformer
